function isNotEmptyString(value: string | null | undefined): boolean {
  return value !== '' && value !== null && value !== undefined;
}

export default isNotEmptyString;
